<template>
  <div>
    <div class="apegar mt-3">
      <div class="row gy-0 pb-5 shadow">
        <div class="col-12"><h2 class="mt-4 mb-3">CLIENTE</h2></div>
        <div class="col-4 rounded mt-5">
          <select
            @change="Empresa($event)"
            class="form-select p-2"
            aria-label="Default select example"
          >
            <option selected>Seleccionar Empresa...</option>
            <option
              class="text-center"
              v-for="empresa in DniEmpre"
              :key="empresa.id"
              :value="empresa.id"
            >
              {{ empresa.empNomCorto }}
            </option>
          </select>
        </div>
        <div class="col-4 rounded mt-5">
          <select
            @change="Centro($event)"
            class="form-select p-2"
            aria-label="Default select example"
          >
            <option selected>Seleccionar Centro ...</option>
            <option
              v-for="centro in CentroCosto"
              :key="centro.id"
              :value="centro.cenCodigo"
            >
              {{ centro.cenNombre }}
            </option>
          </select>
        </div>

        <div class="col-4 rounded mt-5">
          <select
            @change="SubCentro($event)"
            class="form-select p-2"
            aria-label="Default select example"
          >
            <option selected>Seleccionar Centro ...</option>
            <option
              v-for="Subcentro in SubCentroCosto"
              :key="Subcentro.id"
              :value="Subcentro.cenCodigo"
            >
              {{ Subcentro.cenNombre }}
            </option>
          </select>
        </div>

        <div class="roudend">
        
          <button class= "col-12 btn btn-success mt-4 p-2"> INGRESAR CLIENTE</button>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "BYClienteNuevo",

  data() {
    return {
      CentroCosto: [],
      SubCentroCosto: [],
      cenCodigoCentro: "",
      idEmpresa: "",
    };
  },

  mounted() {
    this.dniTrabajador = localStorage.getItem("dniUsers");
  },

  computed: {
    ...mapGetters("users", ["DniEmpre"]),
  },

  methods: {
    Empresa(event) {
      this.CentroCosto = "";
      this.SubCentroCosto= ""
      this.idEmpresa = event.target.value;
      console.log(event.target.value);

      this.axios
        .get(
          `Ccosto/CentroxTrabajador?idEmpresa=${event.target.value}&dniUser=${this.dniTrabajador}`
        )
        .then((r) => {
          this.CentroCosto = r.data;
        });
    },

    Centro(event) {
      this.cenCodigoCentro = event.target.value;

      this.axios
        .get(
          `SubCentro/SubCxTrabajador?codCenCosto=${this.cenCodigoCentro}&dniUser=${this.dniTrabajador}&idEmpresa=${this.idEmpresa}`
        )
        .then((r) => {
          this.SubCentroCosto = r.data;
          console.log(r.data)
        });
    },

    SubCentro(event){
      console.log(event.target.value)
    }
  },
};
</script>

<style scoped>
.apegar {
  padding-left: 18%;
  padding-right: 18%;
}

</style>
